import { API_BASE_URL as BASE } from '@/lib/apiBase'
import { authFetch, authHeaders, handleUnauthorized } from '@/lib/authFetch'
import { auditSearchQuery } from '@/lib/auditCenter'
import type { AuditSearchParams, AuditSearchResult, AuditTrends } from '@/types/audit'

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await authFetch(`${BASE}${path}`, {
    ...init,
    headers: authHeaders(init?.headers),
  })
  if (!res.ok) {
    handleUnauthorized(res.status)
    const text = await res.text().catch(() => res.statusText)
    let message = text
    try {
      const body = JSON.parse(text) as { message?: string | string[] }
      message = Array.isArray(body.message) ? body.message.join('. ') : (body.message ?? text)
    } catch {
      // keep raw text
    }
    throw new Error(message || `API ${init?.method ?? 'GET'} ${path} failed (${res.status})`)
  }
  return res.json() as Promise<T>
}

// The Audit Trail Center (z8nrz7dq6q). Tenant-scoped: authHeaders injects
// X-Tenant-Id for the selected tenant.
export const auditCenterApi = {
  search: (params: AuditSearchParams) => {
    const qs = auditSearchQuery(params).toString()
    return request<AuditSearchResult>(`/audit-center/search${qs ? `?${qs}` : ''}`)
  },

  /** The same search, trended by day, week and month at once (spec page 4). */
  trends: (params: AuditSearchParams) => {
    const qs = auditSearchQuery({ ...params, skip: undefined, take: undefined }).toString()
    return request<AuditTrends>(`/audit-center/trends${qs ? `?${qs}` : ''}`)
  },
}
